// import Vuex from 'vuex'
// import Vue from 'vue'

// Vue.use(Vuex)

import { createStore } from 'vuex'

export default createStore({
  state: {
    pages: [],
    singlePagesNoAds: [],
    sections: [],
    articles: [],
    ads: [],
    currentPage: undefined,
    currentSection: undefined,
    currentArticle: undefined,
    currentArticleChangeIsClick: undefined,
    showScrubber: false,
    showIssueOverview: false,
    printAndDownload: false,
    showArticleModal: false,
    showSharing: false,
    showImageGalleryModal: false,
    showOverlay: false,
    showCrop: false,
    isCurrentPageLoaded: false,
    isCurrentPageRendered: false,
    showRightAlignedNavigationBar: false,
    showLeftAlignedScrubber: false,
    pageSide: 0,
    pageFromSection: undefined,
    articleFontsize: 12,
    articleFontSizeUnit: 'pt',
    isScrolling: false,
    interstitials: undefined,
    initPageLoaded: false,
    pageViewMode: undefined,
    favArticles: [],
    hasGETFullIssue: false,
    hasTtsService: false,
    zoomedPages: [],
    articleViewMode: 'text',
    selectedPageChild: undefined,
    // selectedPageChildChangeIsClick: undefined,
    slidesPageIndexes: [],
    articleMp3Urls: {},
    transitionToPage: undefined,
    showAudioPlayer: false,
    showPrintDownloadConsent: false,
    isPortrait: undefined,
    showPrintMenu: false,
    showCropMenu: false,
    showBurgerMenu: false,
    isInSinglePagesMode: false,
  },
  mutations: {
    setPages (state, pages) {
      state.pages = pages
    },
    setSinglePagesNoAds (state, pages) {
      var noAdsArr = []
      for (var i = 0; i < pages.length; i++) {
        if (pages[i].interstitialAdAfterPage === undefined) {
          noAdsArr.push(pages[i])
        }
      }
      state.singlePagesNoAds = noAdsArr
    },
    setSections (state, sections) {
      state.sections = sections
    },
    setArticles (state, articles) {
      state.articles = articles
    },
    setCurrentPage (state, page) {
      for (var i = 0; i < state.pages.length; i++) {
        if (state.pages[i] === page) {
          state.currentPage = page
        } else if (state.pages[i].firstPage === page || state.pages[i].secondPage === page) {
          state.currentPage = state.pages[i]
        }
      }
    },
    setCurrentPageFromId (state, pageId) {
      for (var i = 0; i < state.pages.length; i++) {
        if (state.pages[i].firstPage.id === pageId || (state.pages[i].secondPage !== null && state.pages[i].secondPage.id === pageId)) {
          state.currentPage = state.pages[i]
          return
        }
      }
    },
    setCurrentSection (state, section) {
      state.currentSection = section
    },
    setCurrentArticle (state, article) {
      state.currentArticle = article
    },
    setCurrentArticleFromClick (state, {article, isClick}) {
      state.currentArticleChangeIsClick = isClick
      state.currentArticle = article
    },
    setCurrentArticleAndSelectedPageChildFromIds (state, ids) {
      var articleId = ids.articleId
      var pageId = ids.pageId

      // This code is only related to "jumpToArticleId" code. Which is not active for MCC.
      // for (var j = 0; j < state.articles.length; j++) {
      //   var article = state.articles[j]
      //   if (pageId !== undefined) {
      //     if (article.json.attributes.JumpOriginArticleId !== undefined && article.id === articleId && article.json.attributes.JumpOriginPageId !== undefined && article.page.id === pageId) {
      //       console.log('jumpski!')
      //       pageId = article.json.attributes.JumpOriginPageId
      //       articleId = state.articles[j].json.attributes.JumpOriginArticleId
      //     }
      //   } else {
      //     // support for issues without JumpOriginPageId.
      //     if (article.json.attributes.JumpOriginArticleId !== undefined && article.id === articleId) {
      //       console.log('the old way')
      //       articleId = state.articles[j].json.attributes.JumpOriginArticleId
      //     }
      //   }
      // }

      for (var i = 0; i < state.singlePagesNoAds.length; i++) {
        const page = state.singlePagesNoAds[i]
        if (pageId === undefined) {
          // support for issues without JumpOriginPageId.
          for (var j = 0; j < page.articles.length; j++) {
            if (page.articles[j].id === articleId) {
              state.currentArticle = page.articles[j]
              state.selectedPageChild = page.articles[j]
              return
            }
          }
          for (var l = 0; l < page.ads.length; l++) {
            if (page.ads[l].id === articleId) {
              state.selectedPageChild = page.ads[l]
              return
            }
          }
        }
        if (pageId === page.id) {
          for (var k = 0; k < page.articles.length; k++) {
            if (page.articles[k].id === articleId) {
              state.currentArticle = page.articles[k]
              state.selectedPageChild = page.articles[k]
              return
            }
          }
          for (var m = 0; m < page.ads.length; m++) {
            if (page.ads[m].id === articleId) {
              state.selectedPageChild = page.ads[m]
              return
            }
          }
        }
      }

      // for (var i = 0; i < state.articles.length; i++) {
      //   if (pageId === undefined) {
      //     // support for issues without JumpOriginPageId.
      //     if (state.articles[i].id === articleId) {
      //       state.currentArticle = state.articles[i]
      //       return
      //     }
      //   } else {
      //     if (state.articles[i].id === articleId && state.articles[i].page.id === pageId) {
      //       state.currentArticle = state.articles[i]
      //       return
      //     }
      //   }
      // }
    },
    setScrubberVisibile (state, showScrubber) {
      state.showScrubber = showScrubber
      if (showScrubber) {
        state.showBurgerMenu = false
      }
    },
    toggleScrubberVisible (state) {
      state.showScrubber = !state.showScrubber
      if (state.showScrubber) {
        state.showBurgerMenu = false
      }
    },
    setShowIssueOverview (state, showIssueOverviewObj) {
      state.showIssueOverview = showIssueOverviewObj.val
      if (showIssueOverviewObj.printAndDownload !== undefined) {
        state.printAndDownload = showIssueOverviewObj.printAndDownload
      }
      if (state.showIssueOverview) {
        state.showBurgerMenu = false
      }
    },
    setShowArticleModal (state, showArticleModal) {
      state.showArticleModal = showArticleModal
      if (showArticleModal) {
        state.showBurgerMenu = false
      }
    },
    setShowSharing (state, showSharing) {
      state.showSharing = showSharing
      if (showSharing) {
        state.showBurgerMenu = false
      }
    },
    setShowImageGalleryModal (state, show) {
      state.showImageGalleryModal = show
      if (show) {
        state.showBurgerMenu = false
      }
    },
    setShowOverlay (state, showOverlay) {
      state.showOverlay = showOverlay
    },
    setShowRightAlignedNavigationBar (state, show) {
      state.showRightAlignedNavigationBar = show
    },
    setShowLeftAlignedScrubber (state, show) {
      state.showLeftAlignedScrubber = show
    },
    setCropVisible(state, showCrop) {
      state.showCrop = showCrop
      if (showCrop) {
        state.showBurgerMenu = false
      }
    },
    setCropPageSide(state, pageSide) {
      state.pageSide = pageSide
    },
    changePageFromSectionsBar (state, page) {
      state.pageFromSection = undefined
      state.pageFromSection = page
    },
    setTransitionToPage (state, page) {
      state.transitionToPage = undefined
      state.transitionToPage = page
    },
    transitionToPageWithArticleId (state, articleId) {
      for (let article of state.articles) {
        if (article.id === articleId) {
          state.transitionToPage = article.page
          return
        }
      }
      for (let ad of state.ads) {
        if (ad.id === articleId) {
          state.transitionToPage = ad.page
          return
        }
      }
    },
    // setHomeUrl (state, homeUrl) {
    //   state.homeUrl = homeUrl
    // },
    // setZoomLevelButton (state, zoomIn) {
    //   state.zoomLevelButton = zoomIn
    //   // if (zoomIn > state.maxZoom) {
    //   //   state.zoomLevelButton = state.maxZoom
    //   //   return
    //   // }
    //   // var newZoomLevel = state.zoomLevel
    //   // if (zoomIn) {
    //   //   newZoomLevel += 0.50
    //   // } else {
    //   //   newZoomLevel -= 0.50
    //   // }
    //   // if (state.zoomLevelButton < 1.0) {
    //   //   state.zoomLevelButton = 1.0
    //   // } else if (state.zoomLevelButton > state.maxZoom) {
    //   //   state.zoomLevelButton = state.maxZoom
    //   // } else {
    //   //   state.zoomLevelButton = newZoomLevel
    //   // }
    // },
    // setZoomScale (state, scale) {
    //   state.zoomLevel = scale
    // },
    // setMaxZoom (state, zoom) {
    //   state.maxZoom = zoom
    // },
    setFontSize (state, increment) {
      if (increment) {
        state.articleFontsize += 1
        this.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleIncreaseFontSizeButtonClick', state.currentArticle, state.articleFontsize + state.articleFontSizeUnit, state.articleFontsize)
      } else {
        state.articleFontsize -= 1
        this.$cciEventTrackingPlugin.trackEvent('ArticleView', 'ArticleDecreaseFontSizeButtonClick', state.currentArticle, state.articleFontsize + state.articleFontSizeUnit, state.articleFontsize)
      }
    },
    setIsScrolling (state, scroll) {
      state.isScrolling = scroll
    },
    // setInterstitialsFrequency (state, freq) {
    //   state.interstitialsFrequency = freq
    // },
    setInterstitials (state, interstitials) {
      state.interstitials = interstitials
    },
    reOrderInterstitials (state) {
      // move the first interstitial to the end of the array
      if (state.interstitials !== undefined && state.interstitials.length > 1) {
        state.interstitials.push(state.interstitials.shift())
      }
    },
    moveInterstitialToFront (state, interstitial) {
      // Remove the interstitial from the array and add it to the front
      state.interstitials.splice(state.interstitials.indexOf(interstitial), 1)
      state.interstitials.unshift(interstitial)
    },
    // setSportsExtraMenuSelected (state, selection) {
    //   state.sportsExtraMenuSelected = selection
    // },
    setInitPageLoaded (state, loaded) {
      state.initPageLoaded = loaded
    },
    setPageViewMode (state, mode) {
      state.pageViewMode = mode
    },
    togglePageViewMode (state) {
      state.pageViewMode = !state.pageViewMode
    },
    setErrorMessage (state, msg) {
      state.errorMessage = msg
    },
    setFavArticles (state, favArticles) {
      state.favArticles = favArticles
    },
    addFavArticle (state, articleId) {
      if (state.favArticles.indexOf(articleId) === -1) {
        state.favArticles.push(articleId)
      }
    },
    removeFavArticle (state, articleId) {
      if (state.favArticles.indexOf(articleId) > -1) {
        state.favArticles.splice(state.favArticles.indexOf(articleId), 1)
      }
    },
    addZoomedPage (state, page) {
      if (state.zoomedPages.indexOf(page) === -1) {
        state.zoomedPages.push(page)
      }
    },
    removeZoomedPage (state, page) {
      if (state.zoomedPages.indexOf(page) > -1) {
        state.zoomedPages.splice(state.zoomedPages.indexOf(page), 1)
      }
    },
    setArticleViewMode (state, mode) {
      state.articleViewMode = mode
    },
    setSelectedPageChild (state, obj) {
      state.selectedPageChild = obj
    },
    // setSelectedPageChildFromClick (state, {obj, isClick}) {
    //   state.selectedPageChildChangeIsClick = isClick
    //   state.selectedPageChild = obj
    // },
    setIsCurrentPageLoaded (state, isLoaded) {
      state.isCurrentPageLoaded = isLoaded
    },
    setIsCurrentPageRendered (state, isRendered) {
      state.isCurrentPageRendered = isRendered
    },
    setSlidesPageIndexes (state, indexes) {
      state.slidesPageIndexes = indexes
    },
    toggleShowAudioPlayer (state) {
      state.showAudioPlayer = !state.showAudioPlayer
    },
    hideAudioPlayer (state) {
      state.showAudioPlayer = false
    },
    setShowPrintDownloadConsent (state, show) {
      state.showPrintDownloadConsent = show
    },
    setShowPrintMenu (state, show) {
      state.showPrintMenu = show
    },
    setShowCropMenu (state, show) {
      state.showCropMenu = show
    },
    closeAllModals (state) {
      state.showArticleModal = false
      state.showSharing = false
      state.showImageGalleryModal = false
      state.showOverlay = false
      state.showCrop = false
      state.showIssueOverview = false
      state.showPrintDownloadConsent = false
      state.showScrubber = false
      state.showBurgerMenu = false
    },
    setShowBurgerMenu (state, show) {
      state.showBurgerMenu = show
    },
    setIsInSinglePagesMode(state, value) {
      state.isInSinglePagesMode = value;
    },
  },
  getters: {
    getPages: state => { return state.pages },
    getSinglePagesNoAds: state => { return state.singlePagesNoAds },
    getSections: state => { return state.sections },
    getArticles: state => { return state.articles },
    getCurrentPage: state => { return state.currentPage },
    getCurrentSection: state => { return state.currentSection },
    getCurrentArticle: state => { return state.currentArticle },
    getShowScrubber: state => { return state.showScrubber },
    getShowIssueOverview: state => { return state.showIssueOverview },
    getPrintAndDownload: state => { return state.printAndDownload },
    getShowArticleModal: state => { return state.showArticleModal },
    getShowImageGalleryModal: state => { return state.showImageGalleryModal },
    getShowSharing: state => { return state.showSharing },
    getShowOverlay: state => { return state.showOverlay },
    getShowCrop: state => { return state.showCrop },
    getShowRightAlignedNavigationBar: state => { return state.showRightAlignedNavigationBar},
    getShowLeftAlignedScrubber: state => { return state.showLeftAlignedScrubber},
    getPageSide: state => { return state.pageSide },
    getPageFromSection: state => { return state.pageFromSection },
    // getHomeUrl: state => { return state.homeUrl },
    // getStartPage: state => { return state.startPage },
    // getMaxZoom: state => { return state.maxZoom },
    getArticleFontsize: state => { return state.articleFontsize },
    getIsScrolling: state => { return state.isScrolling },
    // getInterstitialsFrequency: state => { return state.interstitialsFrequency },
    getInterstitials: state => { return state.interstitials },
    // getToken: state => { return state.token },
    // getSportsExtraMenuSelected: state => { return state.sportsExtraMenuSelected },
    getInitPageLoaded: state => { return state.initPageLoaded },
    getPageViewMode: state => { return state.pageViewMode },
    getFavArticles: state => { return state.favArticles },
    getZoomedPages: state => { return state.zoomedPages },
    getArticleViewMode: state => { return state.articleViewMode },
    getSelectedPageChild: state => { return state.selectedPageChild },
    getIsCurrentPageLoaded: state => { return state.isCurrentPageLoaded },
    getIsCurrentPageRendered: state => { return state.isCurrentPageRendered },
    getSlidesPageIndexes: state => { return state.slidesPageIndexes },
    getTransitionToPage: state => { return state.transitionToPage },
    getShowAudioPlayer: state => { return state.showAudioPlayer },
    getShowPrintDownloadConsent: state => { return state.showPrintDownloadConsent },
    getShowPrintMenu: state => { return state.showPrintMenu },
    getShowCropMenu: state => { return state.showCropMenu },
    getShowBurgerMenu: state => { return state.showBurgerMenu },
    getIsInSinglePagesMode: state => state.isInSinglePagesMode,
  }
})
